




import { Component, Vue } from 'vue-property-decorator'
import UserModule from '@api/module/customer/user/UserModule'
@Component
export default class extends Vue {
  get userPhoto() {
    const defaultDeadImg = require('@design/portal/jskq/assets/images/head-default.jpg')
    return UserModule.getUserPhotoUrl || defaultDeadImg
  }
}
